/**
 * Format price with comma separator
 * @param {BigInt|number|string} x - The price to format
 * @returns {string} The formatted price
 */
const formatPrice = (price, separator = ",") => {
    if (!price || price < 0)
        return "0";

    // Convert number to string and add comma separator
    const priceString = price.toString();
    const parts = [];

    for (let i = priceString.length - 3; i >= 0; i -= 3) {
        parts.unshift(priceString.slice(i, i + 3));
    }

    const remainder = priceString.length % 3;

    if (remainder !== 0) {
        parts.unshift(priceString.slice(0, remainder));
    }

    return parts.join(separator);
}

export default formatPrice;